import React, { useState } from 'react';
import './ComplexNumberCalculator.css';

const ComplexNumberCalculator = () => {
  const [realPart1, setRealPart1] = useState('');
  const [imaginaryPart1, setImaginaryPart1] = useState('');
  const [realPart2, setRealPart2] = useState('');
  const [imaginaryPart2, setImaginaryPart2] = useState('');
  const [operation, setOperation] = useState('add');
  const [result, setResult] = useState('');

  const handleCalculate = () => {
    const num1 = { real: parseFloat(realPart1), imag: parseFloat(imaginaryPart1) };
    const num2 = { real: parseFloat(realPart2), imag: parseFloat(imaginaryPart2) };

    let resultReal, resultImag;

    switch (operation) {
      case 'add':
        resultReal = num1.real + num2.real;
        resultImag = num1.imag + num2.imag;
        break;
      case 'subtract':
        resultReal = num1.real - num2.real;
        resultImag = num1.imag - num2.imag;
        break;
      case 'multiply':
        resultReal = num1.real * num2.real - num1.imag * num2.imag;
        resultImag = num1.real * num2.imag + num1.imag * num2.real;
        break;
      case 'divide':
        const denom = num2.real * num2.real + num2.imag * num2.imag;
        resultReal = (num1.real * num2.real + num1.imag * num2.imag) / denom;
        resultImag = (num1.imag * num2.real - num1.real * num2.imag) / denom;
        break;
      default:
        resultReal = 0;
        resultImag = 0;
    }

    setResult(`(${resultReal} + ${resultImag}i)`);
  };

  return (
    <div className="mt-4">
      <h2 className="text-center mb-4">Complex Number Calculator</h2>
      <div>
        <div>
          <div>
            <div>
              <label>First Number (Real Part)</label>
              <input
                type="number"
                value={realPart1}
                onChange={(e) => setRealPart1(e.target.value)}
              />
            </div>
            <div>
              <label>First Number (Imaginary Part)</label>
              <input
                type="number"
                value={imaginaryPart1}
                onChange={(e) => setImaginaryPart1(e.target.value)}
              />
            </div>
          </div>

          <div className="mt-3">
            <div>
              <label>Second Number (Real Part)</label>
              <input
                type="number"
                value={realPart2}
                onChange={(e) => setRealPart2(e.target.value)}
              />
            </div>
            <div>
              <label>Second Number (Imaginary Part)</label>
              <input
                type="number"
                value={imaginaryPart2}
                onChange={(e) => setImaginaryPart2(e.target.value)}
              />
            </div>
          </div>

          <div className="mt-3">
            <div>
              <label>Operation</label>
              <select
                value={operation}
                onChange={(e) => setOperation(e.target.value)}
              >
                <option value="add">Addition (+)</option>
                <option value="subtract">Subtraction (-)</option>
                <option value="multiply">Multiplication (×)</option>
                <option value="divide">Division (÷)</option>
              </select>
            </div>
          </div>

          <button
            className="mt-3"
            onClick={handleCalculate}
          >
            Calculate
          </button>

          {result && (
            <div className="mt-3">
              <h5>Result:</h5>
              <div>{result}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComplexNumberCalculator;
